import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ZapierRoutingModule } from './zapier-routing.module';
import { ZapierComponent } from './zapier.component';
import { MaterialModule } from '../../material/material.module';
import { BotonToggleModule } from '../../boton/boton-toggle.module';
import { VolverModule } from '../../volver/volver.module';

@NgModule({
  declarations: [ZapierComponent],
  imports: [
    CommonModule,
    ZapierRoutingModule,
    MaterialModule,
    BotonToggleModule,
    VolverModule,
  ]
})
export class ZapierModule { }
